/* eslint-env browser */
(function () {
  const handleSlider = function (slider) {
    if (!slider) return;
    const fitImageHeight = slider.dataset.fitImageHeight === "true";
    const slides = slider.querySelectorAll(".slider__slide");
    const btnLeft = slider.querySelector(".slider__btn--left");
    const btnRight = slider.querySelector(".slider__btn--right");
    const dotsContainer = slider.querySelector(".slider-dots");
    const autoplay = slider.dataset.autoplay;

    let curSlide = 0;
    const maxSlide = slides.length;
    // on touch devices
    let initialX = null;
    let initialY = null;

    // calculate height of each slide
    let height;
    const calculateHeight = function () {
      if (!fitImageHeight) return;
      // calculate ration of data-height-desktop and data-width-desktop and then data-height-mobile and data-width-mobile
      const ratio =
        parseInt(slides[curSlide].dataset.heightDesktop, 10) /
        parseInt(slides[curSlide].dataset.widthDesktop, 10);
      const ratioMobile =
        parseInt(slides[curSlide].dataset.heightMobile, 10) /
        parseInt(slides[curSlide].dataset.widthMobile, 10);
      const width = window.innerWidth;
      if (width > 768) {
        height = width * ratio;
      } else {
        height = width * ratioMobile;
      }

      slider.style.height = `${height}px`;
    };

    if (fitImageHeight) {
      calculateHeight();
      window.addEventListener("resize", calculateHeight);
    }

    const createDots = function () {
      if (!dotsContainer) return;
      slides.forEach((_, i) => {
        dotsContainer.insertAdjacentHTML(
          "beforeend",
          `<span class="slider-dots__dot" data-slide="${i}"></span>`
        );
      });
    };

    createDots();

    const activateDot = function (slide) {
      if (!dotsContainer) return;
      document
        .querySelectorAll(".slider-dots__dot")
        .forEach((dot) => dot.classList.remove("slider-dots__dot--active"));
      document
        .querySelector(`.slider-dots__dot[data-slide="${slide}"]`)
        .classList.add("slider-dots__dot--active");
    };

    const goToSlide = function (slide) {
      slides.forEach((s, i) => {
        s.style.transform = `translateX(${100 * (i - slide)}%)`;
      });

      calculateHeight();

      activateDot(slide);
    };

    goToSlide(0);

    const nextSlide = function () {
      if (curSlide !== maxSlide - 1) {
        curSlide += 1;
      } else {
        curSlide = 0;
      }

      calculateHeight();

      goToSlide(curSlide);
    };

    const prevSlide = function () {
      if (curSlide !== 0) {
        curSlide -= 1;
      } else {
        curSlide = maxSlide - 1;
      }

      goToSlide(curSlide);
    };

    function startTouch(e) {
      initialX = e.touches[0].clientX;
      initialY = e.touches[0].clientY;
    }

    function moveTouch(e) {
      if (initialX === null) {
        return;
      }

      if (initialY === null) {
        return;
      }

      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;

      const diffX = initialX - currentX;
      const diffY = initialY - currentY;

      if (Math.abs(diffX) > Math.abs(diffY)) {
        e.preventDefault();
        // sliding horizontally
        if (diffX > 0) {
          // swiped left
          nextSlide();
        } else {
          // swiped right
          prevSlide();
        }
      }

      initialX = null;
      initialY = null;
    }

    const handleKeyDown = function (e) {
      if (e.key === "ArrowLeft") prevSlide();
      if (e.key === "ArrowRight") nextSlide();
    };

    const handleAutoplay = function (time) {
      setInterval(() => {
        nextSlide();
      }, time * 1000);
    };

    if (autoplay) {
      handleAutoplay(parseInt(autoplay, 10));
    }

    if (slides.length <= 1) return;
    btnRight.addEventListener("click", nextSlide);
    btnLeft.addEventListener("click", prevSlide);
    slider.addEventListener("touchstart", startTouch, false);
    slider.addEventListener("touchmove", moveTouch, false);
    document.addEventListener("keydown", handleKeyDown);
  };

  const sliders = document.querySelectorAll(".slider");
  if (!sliders) return;
  sliders.forEach((slider) => {
    handleSlider(slider);
  });
})();
